import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=2da976a9&scoped=true"
import script from "./notification.vue?vue&type=script&lang=js"
export * from "./notification.vue?vue&type=script&lang=js"
import style0 from "./notification.vue?vue&type=style&index=0&id=2da976a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da976a9",
  null
  
)

export default component.exports